<template>
  <div class="user-notification">
    <span v-if="unseenCount" class="notification-counter">
      <!-- <span class="mx-1">
      </span> -->
      {{ unseenCount }}
    </span>
    <b-dropdown
      id="dropdown-1"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
      @show="openNotifactionDropdown"
    >
      <template #button-content>
        <img src="@/assets/icons/notification.svg" />
      </template>
      <b-dropdown-text>
        <div class="row py-2">
          <div class="col-6">
            <a class="notification-label"
              >الإشعارات
              <span
                v-if="unseenCount >= 1"
                @click="showUnseenOnly = !showUnseenOnly"
              >
                {{ unseenCount }}
              </span></a
            >
          </div>
          <div class="col-6 text-start">
            <a
              v-if="notificationList.length"
              @click="seeAllNotifications"
              class="see-all p-0"
            >
              تحديد الكل كمقروء
            </a>
          </div>
        </div>
      </b-dropdown-text>
      <div
        class="all-notification-list"
        v-if="notificationList.length"
        @scroll="handleScroll"
      >
        <b-dropdown-text v-for="(item, i) in notificationList" :key="i">
          <notificationItem
            @changeItemSeen="changeItemSeen($event)"
            @removeItem="removeItem($event)"
            :item="item"
          ></notificationItem>
        </b-dropdown-text>
      </div>
      <b-dropdown-text
        class="show-all-notifications"
        v-if="!notificationList.length && !loader"
      >
        <p class="text-center">
          {{
            showUnseenOnly ? "لا توجد اشعارات غير مقروءة" : "لا توجد اشعارات"
          }}
        </p>
      </b-dropdown-text>
      <div class="text-center" v-if="loader">
        <b-spinner type="grow"></b-spinner>
      </div>
      <b-dropdown-text
        v-if="notificationList.length && !loader"
        class="show-all-notifications"
      >
        <router-link class="see-all" to="/notifications">
          عرض جميع الإشعارات
        </router-link>
      </b-dropdown-text>
    </b-dropdown>
  </div>
</template>

<script>
import {
  notificationsList,
  UnseenCount,
  markAllAsSeen,
} from "@/api/notifications";
import notificationItem from "@/components/global/notificationItem/index.vue";
export default {
  data: () => {
    return {
      notificationList: [],
      debounc: null,
      isDropdown2Visible: false,
      dateUtc: "",
      unseenCount: 0,
      showUnseenOnly: false,
      loader: false,
    };
  },
  computed: {
    isThereNewNotification() {
      return this.$store.state.notification.newNotification;
    },
    isThereUpdate() {
      return this.$store.state.notification.updateFromAllNotificationsList;
    },
  },
  components: {
    notificationItem,
  },
  created() {
    this.getUnseenCount();
  },
  mounted: function () {
    this.$root.$on("bv::dropdown::show", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = true;
      }
    });
    this.$root.$on("bv::dropdown::hide", (bvEvent) => {
      if (bvEvent.componentId === "dropdown-2") {
        this.isDropdown2Visible = false;
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault();
      }
    });
  },
  methods: {
    openNotifactionDropdown() {
      this.notificationList = [];
      this.dateUtc = "";
      this.getData();
      this.getUnseenCount();
    },
    async getData() {
      this.loader = true;
      let paramsObj = {
        count: 5,
        ...(this.dateUtc && { beforeDateUtc: this.dateUtc }),
        ...(this.showUnseenOnly && { isSeen: false }),
      };

      let result = await notificationsList(paramsObj);
      if (result) {
        this.notificationList = [
          ...this.notificationList,
          ...result.notifications,
        ];
      }
      this.loader = false;
    },
    async getUnseenCount() {
      let result = await UnseenCount();
      if (result) {
        this.unseenCount = result;
      } else this.unseenCount = 0;
    },
    fireScrollList() {
      this.dateUtc =
        this.notificationList.length > 0
          ? this.notificationList[this.notificationList.length - 1].sentTimeUTC
          : null;
      clearTimeout(this.debounc);
      this.debounc = setTimeout(() => {
        this.getData();
      }, 300);
    },
    handleScroll(el) {
      if (
        el.target.offsetHeight + el.target.scrollTop >=
        el.target.scrollHeight
      ) {
        this.fireScrollList();
      }
    },
    async seeAllNotifications() {
      let payload = { isSeen: true };
      let result = markAllAsSeen(payload);
      if (result) {
        this.notificationList.map((item) => (item.isSeen = true));
        this.unseenCount = 0;
      }

      this.updateAllNotifications();
    },
    changeItemSeen(id) {
      const index = this.notificationList.findIndex(
        (obj) => obj.notificationId === id
      );
      this.notificationList[index].isSeen = true;
      this.getUnseenCount();
      this.updateAllNotifications();
    },
    removeItem(item) {
      const index = this.notificationList.findIndex(
        (obj) => obj.notificationId === item.notificationId
      );
      this.notificationList.splice(index, 1);
      this.getUnseenCount();
      this.updateAllNotifications();
    },
    updateAllNotifications() {
      this.$store.commit("notification/updateAllNotifications", true);
      setTimeout(() => {
        this.$store.commit("notification/updateAllNotifications", false);
      }, 4000);
    },
    updateList() {
      setTimeout(() => {
        this.openNotifactionDropdown();
      }, 1000);
    },
  },
  watch: {
    showUnseenOnly() {
      this.notificationList = [];
      this.dateUtc = "";
      this.getData();
    },
    isThereNewNotification(newVal) {
      if (newVal) {
        this.updateList();
      }
    },
    isThereUpdate(newVal) {
      if (newVal) {
        this.updateList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "_style.scss";
</style>
